module.exports = __webpack_public_path__ + "media/images/new-ui-images/iconizer-icon-blue-383cefde394b7ab71902dfcb23e35548.svg";